<template>
  <div>
    <!--
    <b-row style="border-bottom: 1px solid #dcdcdc;" class="mr-0 mb-3">
      SCENA: {{ JSON.stringify(scene) }}
    </b-row>
    -->
    <b-row v-bind:key="j" v-for="(day, j) in daysData.days" class="mb-1">
      <b-col cols="12">
        <day :day='day' :scene='scene' />
      </b-col>
    </b-row>
   </div>
</template>

<script>
  import Day from './Day'

  export default {
    components: { Day },
    props: ['scene', 'daysData'],
    data() {
      return {}
    }
  }
</script>

